import React from "react";
import { useParams, useLocation } from "react-router-dom";
import TripScheduleContainer from "../../containers/ScheduleServiceContainer/TripScheduleContainer/TripScheduleContainer";

const TripScheduleServicePage = () => {
  const params: { careTakerId: string; serviceUserId: string } = useParams();
  const location = useLocation();
  const queryParams = new URLSearchParams(location.search);
  const date = queryParams.get("date") && queryParams.get("date");
  return <TripScheduleContainer params={params} date={date && date} />;
};

export default TripScheduleServicePage;
